<template>
    <div class="profile-card-competencies">
        <template v-for="(score, scoreIndex) in visibleScores" :key="scoreIndex">
            <div class="profile-card-competencies-item">
                <div class="title">{{ score.title }} / <span class="title-duration">{{ score.duration }}</span></div>
                <ProfileProgressBar
                    :percentage="score.duration_percentage"
                    :main-filters="mainFilters"
                    :tag-id="score.id"
                />
            </div>
        </template>
        <div class="show-more-button-wrapper" v-if="scores.length > defaultLength">
            <div
                class="show-more-button"
                @click="maxLength += step"
                v-if="maxLength < scores.length"
            >
                {{ $trans('web_search.filters.show_more') }}
            </div>
            <div
                class="show-less-button"
                @click="maxLength = defaultLength"
                v-if="maxLength >= scores.length"
            >
                {{ $trans('web_search.filters.show_less') }}
            </div>
        </div>
    </div>
</template>


<script>
import ProfileProgressBar from './ProfileProgressBar.vue';

export default {
    components: {
        ProfileProgressBar,
    },
    props: {
        scores: {
            type: Array,
            required: true,
        },
        mainFilters: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            defaultLength: 5,
            maxLength: 5,
            step: 5,
        };
    },
    computed: {
        visibleScores() {
            return this.scores.slice(0, this.maxLength);
        },
    },
};
</script>


<style scoped>
.profile-card-competencies {
    display: flex;
    flex-wrap: wrap;
    gap: 3px;
}

.profile-card-competencies-item {
    display: contents;
    flex-direction: column;
    align-items: center;
}

.show-more-button,
.show-less-button {
    cursor: pointer;
    font-size: 14px;
    color: #41ABC4;
}

.show-more-button:hover,
.show-less-button:hover {
    color: #2E7282;
}

.title {
    text-align: left;
    font: normal normal normal 15px/22px Barlow;
    letter-spacing: -0.27px;
    color: #343433;
    opacity: 1;
}

.title-duration {
    font: normal normal normal 13px/22px Barlow;
}

.show-more-button-wrapper {
    margin-left: 70%;   
}
</style>

